import { API } from "../../App";

export default function AdminCommentsTab({ 
  blogComments, 
  pendingCommentsCount, 
  adminKey, 
  onRefresh 
}) {
  const moderateComment = async (commentId, approve) => {
    try {
      await fetch(`${API}/admin/blog/comments/${commentId}?admin_key=${adminKey}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ is_approved: approve })
      });
      onRefresh();
    } catch (err) {
      alert("Failed to moderate comment");
    }
  };

  const deleteComment = async (commentId) => {
    if (!confirm("Delete this comment?")) return;
    try {
      await fetch(`${API}/admin/blog/comments/${commentId}?admin_key=${adminKey}`, { method: "DELETE" });
      onRefresh();
    } catch (err) {
      alert("Failed to delete comment");
    }
  };

  return (
    <div>
      <h2 className="text-xl font-medium text-[#2D2A26] mb-6">Comment Moderation</h2>
      
      {pendingCommentsCount > 0 && (
        <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
          <p className="text-yellow-700">
            <strong>{pendingCommentsCount}</strong> comment{pendingCommentsCount !== 1 ? 's' : ''} awaiting approval
          </p>
        </div>
      )}

      <div className="space-y-4">
        {blogComments.map(comment => (
          <div key={comment.comment_id} className="bg-white rounded-xl border border-[#E8E4DE] p-5">
            <div className="flex items-start justify-between gap-4 mb-3">
              <div>
                <p className="font-medium text-[#2D2A26]">{comment.user_name}</p>
                <p className="text-sm text-[#6E6A66]">
                  on <span className="text-[#A87C6D]">{comment.post_title}</span>
                </p>
              </div>
              <span className="text-xs text-[#A8A4A0]">
                {new Date(comment.created_at).toLocaleDateString()}
              </span>
            </div>
            
            <p className="text-[#2D2A26] bg-[#F9F7F4] p-3 rounded-lg mb-4">
              {comment.content}
            </p>

            {comment.parent_comment_id && (
              <p className="text-xs text-[#A8A4A0] mb-3">↳ Reply to another comment</p>
            )}

            <div className="flex gap-2">
              <button
                onClick={() => moderateComment(comment.comment_id, true)}
                className="px-4 py-2 text-sm bg-green-500 text-white rounded-lg hover:bg-green-600"
                data-testid={`approve-comment-${comment.comment_id}`}
              >
                Approve
              </button>
              <button
                onClick={() => moderateComment(comment.comment_id, false)}
                className="px-4 py-2 text-sm bg-[#F5F2EE] text-[#6E6A66] rounded-lg hover:bg-[#E8E4DE]"
              >
                Reject
              </button>
              <button
                onClick={() => deleteComment(comment.comment_id)}
                className="px-4 py-2 text-sm text-red-500 border border-red-200 rounded-lg hover:bg-red-50"
              >
                Delete
              </button>
            </div>
          </div>
        ))}

        {blogComments.length === 0 && (
          <div className="text-center py-12 text-[#6E6A66]">
            No pending comments to review.
          </div>
        )}
      </div>
    </div>
  );
}
